import React from "react";
import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { Button } from "react-bootstrap";

class Tractors extends React.Component {
  sendBaseData(serialNr) {
    const tractorIds =
      serialNr ||
      this.props.tractors
        .filter((t) => !t.receiveOnly)
        .map((t) => t.serialNr)
        .join(",");
    if (!tractorIds.length > 0) {
      return cropr.notify("danger", gettext("No tractors found for this account."));
    }
    if (
      cropr.confirm(
        gettext(
          "Do you want to send base ISOBus data to the following tractors? We will send all current cropfields, stock, appliers to the machine, but no planned tasks."
        ) +
          "\n\n" +
          gettext("Tractors") +
          ": " +
          tractorIds
      )
    ) {
      let form = new FormData();
      form.append("tractorIds", tractorIds);
      form.append("plan", cropr.mainplan.id);
      fetch("/apps/cloudfarm/send_iso_data/", {
        method: "POST",
        credentials: "same-origin",
        body: form,
        headers: { "X-CSRFToken": cropr.getCookie("csrftoken") },
      }).then((response) => {
        if (response.ok) {
          cropr.notify("success", gettext("Done"));
        } else {
          cropr.notify("danger", gettext("Failure"));
        }
      });
    }
  }

  render() {
    return (
      <>
        <h4 className="mt-2">
          {this.props.accountName && (
            <>
              {gettext("Currently linked account")}:&nbsp;{this.props.accountName}
            </>
          )}
          {!this.props.noActions && (
            <Button
              variant="primary"
              className="btn-sm float-right"
              onClick={() => this.sendBaseData()}
            >
              <i className="fas fa-upload" />
              {" " + gettext("Send base data to all machines")}
            </Button>
          )}
        </h4>

        <div className="mt-4">
          {this.props.tractors.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  {this.props.headers.map((h, i) => (
                    <th key={i}>{h}</th>
                  ))}
                  {!this.props.noActions && <th>{gettext("Actions")}</th>}
                </tr>
              </thead>
              <tbody>
                {this.props.tractors.map((t, i) => (
                  <tr key={i}>
                    {t.display.map((d, j) => (
                      <td key={j}>{d}</td>
                    ))}
                    {!this.props.noActions && (
                      <td>
                        <Button
                          disabled={t.receiveOnly}
                          onClick={() => this.sendBaseData(t.serialNr)}
                          variant="secondary"
                          className="btn-sm float-right"
                        >
                          {gettext("Send base data")}
                        </Button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            gettext("No tractors found for this account.")
          )}
        </div>
      </>
    );
  }
}

export default Tractors;
